import React, { useEffect, useState } from "react";
import useAppConfig from "../../../config/useAppConfig";
import { printImg } from "../../../master/Print";
import StudentDemoForm1 from "../../components/StudentDemoForm1";
import StudentDemoForm2 from "../../components/StudentDemoForm2";
import { studentDetailsFromDetails } from "../../../../api/StudentDetails";
import { SweetAlertShow } from "../../../master/Master";

export default function StudentDemoForm({ id }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const config = useAppConfig("Student", "student_demo_form");

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    const getStudentDetailsMain = async () => {
      setLoading(true);

      try {
        const response = await studentDetailsFromDetails(id);

        if (response?.data?.status) {
          setData(response.data.data);
        } else {
          SweetAlertShow(
            "info",
            "Warning",
            response?.data?.message || "Student details not found"
          );
        }
      } catch (error) {
        SweetAlertShow(
          "error",
          "Error",
          error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
        );
      } finally {
        setLoading(false);
      }
    };

    getStudentDetailsMain();
  }, [id]);

  if (loading) {
    return (
      <div className="card">
        <div className="card-body text-center">
          <div className="spinner-border text-primary" role="status" />
          <p className="mt-2 mb-0">Loading demo form...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-body overflow-auto">
        <div className="row">
          <div className="col-12 text-end mb-2">
            <button
              type="button"
              className="btn btn-info"
              onClick={() => printImg("PrintDiv")}
            >
              <i className="ri-printer-line" />
            </button>
          </div>

          <div className="col-12" id="PrintDiv">
            {config?.value?.trim() === "student_demo_form_1" ? (
              <StudentDemoForm1 data={data} />
            ) : config?.value?.trim() === "student_demo_form_2" ? (
              <StudentDemoForm2 data={data} />
            ) : (
              <div className="alert alert-warning">
                Demo form configuration not found.
                <br />
                Current value: {String(config?.value ?? "undefined")}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}